/* eslint-disable no-case-declarations */
import { Reducer } from "redux";

import { DestinationSlug } from "../destinations/types";
import { LoadedDestinationInfo } from "../types/global";

export const SET_DESTINATION_DATA = "SET_DESTINATION_DATA";
export const SET_SINGLE_DESTINATION_CONFIG = "SET_SINGLE_DESTINATION_CONFIG";
export const SET_SINGLE_DESTINATION_SETTINGS =
  "SET_SINGLE_DESTINATION_SETTINGS";
export const SET_SINGLE_DESTINATION_SINGLE_SETTING =
  "SET_SINGLE_DESTINATION_SINGLE_SETTING";

export type DestinationState = {
  data: { [id: string]: LoadedDestinationInfo };
  loading: boolean;
};

export const initialDestinationState = {
  data: {},
  loading: true,
};

// Actions
type SetDestinationDataAction = {
  type: typeof SET_DESTINATION_DATA;
  payload: { [id: string]: LoadedDestinationInfo };
};

type SetSingleDestinationConfigAction = {
  type: typeof SET_SINGLE_DESTINATION_CONFIG;
  payload: { [id: string]: LoadedDestinationInfo };
};

type SetSingleDestinationSettingsAction = {
  type: typeof SET_SINGLE_DESTINATION_SETTINGS;
  payload: {
    destinationId: string;
    settings: Record<string, any>;
  };
};

type SetSingleDestinationSingleSetting = {
  type: typeof SET_SINGLE_DESTINATION_SINGLE_SETTING;
  payload: {
    destinationId: string;
    name: string;
    value: any;
  };
};

type DestinationActions =
  | SetDestinationDataAction
  | SetSingleDestinationConfigAction
  | SetSingleDestinationSettingsAction
  | SetSingleDestinationSingleSetting;

const destinationsReducer: Reducer<DestinationState, DestinationActions> = (
  state = initialDestinationState,
  action
): DestinationState => {
  let existingConfig, newConfig, destinationId;

  switch (action.type) {
    case SET_DESTINATION_DATA:
      return { ...state, data: { ...action.payload }, loading: false };

    case SET_SINGLE_DESTINATION_CONFIG:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };

    // TODO CJ SET_SINGLE_DESTINATION_SETTINGS is not used in the codebase
    case SET_SINGLE_DESTINATION_SETTINGS:
      destinationId = action.payload.destinationId;
      existingConfig = state.data[destinationId] || {};

      newConfig = {
        ...existingConfig,
        settings: action.payload.settings,
      };

      return {
        ...state,
        data: { ...state.data, [destinationId]: newConfig },
      };

    // TODO CJ SET_SINGLE_DESTINATION_SINGLE_SETTING is not used in the codebase
    case SET_SINGLE_DESTINATION_SINGLE_SETTING:
      destinationId = action.payload.destinationId;
      existingConfig = state.data[destinationId];

      if (!existingConfig) {
        return state;
      }

      let existingSettings = existingConfig.settings;

      return {
        ...state,

        data: {
          ...state.data,

          [action.payload.destinationId]: {
            ...existingConfig,

            settings: {
              ...existingSettings,
              [action.payload.name]: action.payload.value,
            },
          },
        },
      };
    default:
      return state;
  }
};

export default destinationsReducer;
